function getStoredUser() {
    try {
        const stored_user = localStorage.getItem('user');
        return stored_user ? JSON.parse(stored_user) : null;
    } catch (error) {
        localStorage.removeItem('user');
        return null;
    }
}

export function authHeader() {
    // return authorization header with jwt token
    const AdminUser = getStoredUser();
    if (AdminUser && AdminUser.token) {
    	var allowedOrigins = '*';
        // var allow_headers = "Referer,Accept,Origin,User-Agent,Content-Type";
        return { 
        	'Authorization': 'Bearer ' + AdminUser.token , 
        	'Content-Type': 'application/json, multipart/form-data',
        	"Access-Control-Allow-Origin": allowedOrigins,
        	"Access-Control-Allow-Methods": "PUT,GET,POST,DELETE,OPTIONS" ,
        	"Access-Control-Allow-Headers": "Content-Type, Authorization",
            // "Access-Control-Allow-Headers" : allow_headers,
            "WWW-Authenticate": "Basic",
            "Access-Control-Allow-Credentials": true
        };
    } else {
        return {};
    }
}

export function pusherAuthHeader() {
    const admin_user = getStoredUser();
    if (admin_user && admin_user.token) {
        return {
            Authorization: 'Bearer ' + admin_user.token,
        };
    }
    return {};
}